/**
 * @generated SignedSource<<29692244f8a95451a1fec28446c3f841>>
 * @relayHash d8d011883e1a12813e5845c63b1d7d27
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ad778db0db3ad03ed0c77a087dee3ee77637ddb80a27d5d02009849e20ccbd21

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraSoftwareTimelineAppQuery } from './JiraSoftwareTimelineAppQuery.graphql';

const node: PreloadableConcreteRequest<JiraSoftwareTimelineAppQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "ad778db0db3ad03ed0c77a087dee3ee77637ddb80a27d5d02009849e20ccbd21",
    "metadata": {},
    "name": "JiraSoftwareTimelineAppQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
